import { useLocation, useParams } from 'react-router';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import defaultImage from "../../assets/svg/defultImage.svg";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router';
import { Modal } from 'react-bootstrap';
import { Circle, DriveFolderUpload } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
const CheckOrderItems = () => {


const { id: orderId } = useParams()
const location = useLocation()
// const order = location.state?.order
     const token = localStorage.getItem("token");
        const [order, setOrder] = useState(null);
        const [itemStatus, setItemStatus] = useState({}) 
        const [loading, setLoading] = useState(true)
        const [isChecked, setIsChecked] = useState({})
        const [isInspectionSaved, setIsInspectionSaved] = useState(false);
        const [isAfterImagesUploaded, setIsAfterImagesUploaded] = useState(false);
        const [inspectionStatus, setInspectionStatus] = useState({});
        const [otherItems, setOtherItems] = useState([]);
        const [otherItemStatus, setOtherItemStatus] = useState([]);


const getOrders = async () => {
  try {
    const response = await axios.get(
      `${newHost}stuff/get-order-products/${orderId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const order = response.data.data?.data;

    const statuses = {};
    order?.categories?.forEach(category =>
      category.subcategories?.forEach(sub =>
        sub.items?.forEach(item => {
          if (item.item_type === "other_request_service") return;

          statuses[item.id] = {
            id: item.id,
            orderId: order.id,
            type: "normal",
            slug: category.slug,
            status: item.status || "pending",
            notes: item.rejection_reason || "",
            file: item.image_url || null
          };
        })
      )
    );
    order?.other_requests?.forEach(request =>
      request.services?.forEach(item => {
        statuses[item.id] = {
          id: item.id,
          orderId: order.id,
          requestId: request.id,
          type: "other",
          isAccepted: item.status === "accepted_by_user",
          status: item.engineer_status || "pending",
          notes: item.engineer_rejection_reason || "",
          file: item.engineer_image_url || null
        };
      })
    );

    setInspectionStatus(statuses);
    setOrder(order);
    setOtherItems(order.other_requests || []);

    const hasSavedChecks = Object.values(statuses).some(
      item =>
        item.status === "executed" ||
        item.status === "rejected"
    );

    setIsInspectionSaved(hasSavedChecks);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};


const validInspectionItems = Object.values(inspectionStatus).filter(
  item =>
    item.type === "normal" && item.slug !== "cover" ||
    (item.type === "other" && item.isAccepted)
);

const isAllItemsChecked =
  validInspectionItems.length > 0 &&
  validInspectionItems.every(
    item =>
      item.status === "executed" ||
      item.status === "rejected"
  );


const getImagesAfter = async () => {
  try {
    const response = await axios.get(
      `${newHost}stuff/get-after-images/${orderId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    const images = response.data.data?.images_after || [];
    setIsAfterImagesUploaded(images.length > 0);

  } catch (error) {
    console.log(error.response);
  }
};     
   useEffect(() => {
     getOrders()
      getImagesAfter()
      }, [])
     

     const boxStyle = {
              width: 25,
              height: 25,
              border: "2px solid #D1D5DB",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            };


const handleStatusChange = (id, status, orderId) => {
  setInspectionStatus(prev => ({
    ...prev,
    [id]: {
      ...prev[id],
      status,
      orderId
    }
  }));
};
const submitItemsStatus = async (orderId) => {
  const formData = new FormData();

  const checkedItems = Object.values(inspectionStatus).filter(
    item =>
      item.orderId == orderId &&
      (item.status === "executed" ||
        item.status === "rejected")
  );

  const normalItems = checkedItems.filter(
    item => item.type === "normal"
  );

  const otherItems = checkedItems.filter(
    item => item.type === "other"
  );

  // =========================
  // NORMAL ITEMS
  // =========================
  normalItems.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.id);
    formData.append(
      `items[${index}][status]`,
      item.status
    );

    if (item.status === "rejected") {
      formData.append(
        `items[${index}][rejection_reason]`,
        item.notes || ""
      );

      if (item.file instanceof File) {
        formData.append(
          `items[${index}][image]`,
          item.file
        );
      }
    }
  });

  // =========================
  // OTHER REQUEST ITEMS
  // =========================
  otherItems.forEach((item, index) => {
    formData.append(
      `other_requests[${index}][id]`,
      item.id
    );

    formData.append(
      `other_requests[${index}][status]`,
      item.status
    );

    if (item.status === "rejected") {
      formData.append(
        `other_requests[${index}][rejection_reason]`,
        item.notes || ""
      );

      if (item.file instanceof File) {
        formData.append(
          `other_requests[${index}][image]`,
          item.file
        );
      }
    }
  });

  try {
    const response = await axios.post(
      `${newHost}stuff/store-order-check/${orderId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    toast.success(response.data.message);

    setIsInspectionSaved(true);

    navigate(
      `/ordersExecution/checkItems/${orderId}/imageAfter`
    );

  } catch (error) {
    console.log(error);
    toast.error(error.response?.data?.errors?.message);
  }
};




           const [showModal, setShowModal] = useState(false);
           const [currentItem, setCurrentItem] = useState(null);
           const [noteValue, setNoteValue] = useState("");
           const [imagePreview, setImagePreview] = useState(null)
           const [selectedFile, setSelectedFile] = useState(null);



     const openModal = (service) => {
 const item = inspectionStatus[service.id];

if (item?.status !== "rejected") return;

setCurrentItem(service);
setNoteValue(item.notes || "");
setSelectedFile(item.file || null);

setImagePreview(
  item.file && typeof item.file === "string"
    ? `${newImageUrl}${item.file}`
    : null
);

setShowModal(true);

  }
 const saveNote = (note) => {
  if (!currentItem) return;

  setInspectionStatus(prev => ({
    ...prev,
    [currentItem.id]: {
      ...prev[currentItem.id],
      notes: note,
      file:
        selectedFile ||
        prev[currentItem.id]?.file ||
        null
    }
  }));

  setShowModal(false);
};
        

    const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };
   const [showExecuteModal, setShowExecuteModal] = useState(false)
  
    const handleCloseModal = () => {
      setShowExecuteModal(false)
    }

  const endOrderExecution = async () => {
  
    try {
      const response = await axios.get(`${newHost}stuff/end-execution/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      handleCloseModal()
      getOrders()

    } catch (error) {
      console.log(error.response);
      toast.error(error.response?.data?.errors?.message)
    }
  }
const navigate = useNavigate()


  const handleAction = () => {
  if (order.status === "arrived_at_location") {
    navigate(`/ordersExecution/checkItems/${orderId}/imageBefore`, { state: { order } })
  }

else if (order.status === "in_progress") {
  if (!isInspectionSaved) {
    submitItemsStatus(orderId);
    
  } 
  else if (!isAfterImagesUploaded) {
    navigate(`/ordersExecution/checkItems/${orderId}/imageAfter`);
  } 
  else {
    setShowExecuteModal(true);
  }
}

  else if (order.status === "awaiting_payment") {
    navigate(`/ordersExecution/checkItems/${orderId}/confirmPayment`);
  }
};

const isDisabled = order?.status !== "in_progress";
  const renderServiceRow = (service) => {
  const itemData = inspectionStatus[service.id];
  const hasAttachment =
    itemData?.notes || itemData?.file;

  return (
    <div
      key={service.id}
      className="row align-items-center border-bottom py-3"
    >
      {/* STATUS */}
      <div className="col-md-4 d-flex align-items-center gap-2">
        <Checkbox
          disabled={isDisabled}
          checked={
            inspectionStatus[service.id]?.status ===
            "executed"
          }
          onChange={() =>
      handleStatusChange(
        service.id,
        "executed",
        order?.id
      )
}
          icon={<div style={boxStyle} />}
          checkedIcon={
            <div
              style={{
                ...boxStyle,
                backgroundColor: "#3FBEAC"
              }}
            >
              <CheckIcon
                style={{ color: "#fff", fontSize: 18 }}
              />
            </div>
          }
        />

        <Checkbox
          disabled={isDisabled}
          checked={
            inspectionStatus[service.id]?.status ===
            "rejected"
          }
          onChange={() =>
            handleStatusChange(
              service.id,
              "rejected",
              order?.id
            )
          }
          icon={<div style={boxStyle} />}
          checkedIcon={
            <div
              style={{
                ...boxStyle,
                backgroundColor: "#A80101"
              }}
            >
              <CloseIcon
                style={{ color: "#fff", fontSize: 18 }}
              />
            </div>
          }
         
        />

        <p className="m-0">
          {service.service_name || service.title}
        </p>
      </div>

      {/* PRICE */}
      <div className="col-md-4">
        {Number(service.final_price).toLocaleString(
          "en-US"
        )}{" "}
        ج.م
      </div>

      {/* NOTES */}
      <div className="col-md-4 d-flex justify-content-end">
        <div
          className="position-relative"
          onClick={() => openModal(service)}
        >
          <img
            src={noteIcon}
            alt="note"
            style={{
              width: 24,
              cursor: "pointer"
            }}
          />

          {hasAttachment && (
            <Circle
              sx={{
                fontSize: 8,
                color: "#FF0B0B",
                position: "absolute",
                top: 0,
                right: 0
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
const allowedStatuses = [
  "arrived_at_location",
  "in_progress",
  "awaiting_payment"
];

  return ( 
    <>
      <Modal show={showExecuteModal} onHide={handleCloseModal} dialogClassName='custom-modal-campaigns-width'>
            <Modal.Header className='d-flex align-items-center' >
              <Modal.Title className='fw-bold fs-5 text-center m-0'>
                تأكيد إنهاء الطلب
              </Modal.Title>
    
            </Modal.Header>
            <Modal.Body className='m-2' style={{ direction: "rtl" }}>
              <div className="text-center">
                <h5 className='main-modal-color'>هل أنت متأكد من إنهاء هذا الطلب؟ سيتم حفظ جميع البيانات وإغلاق الطلب بعد تأكيدك.</h5>
              </div>
              <div className='my-4'>
                <h6>
                  يرجى التأكد من الآتي قبل الإنهاء:
                </h6>
                <ul className='mx-4' style={{ listStyleType: "square", color: "#535353" }}>
                  <li className='my-2'>تم تنفيذ جميع الخدمات المطلوبة.</li>
                  <li className='my-2'>تم مراجعة التنفيذ بدقة.</li>
                  <li className='my-2'>لا توجد ملاحظات أو خدمات ناقصة.</li>
                </ul>
              </div>
            
              <div className="d-flex justify-content-center align-items-center  gap-4">
    
                <button onClick={endOrderExecution} className="btn btn-dark px-4">تأكيد وانهاء الطلب</button>
                <button onClick={handleCloseModal} className="btn btn-light px-5">الغاء</button>
    
              </div>
            </Modal.Body>
    
          </Modal>
     <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName='custom-modal-campaigns-width'>
        <Modal.Header className='d-flex align-items-center' >
          <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
            إضافة تفاصيل للخدمه
          </Modal.Title>

        </Modal.Header>
        <Modal.Body className='m-2' style={{ direction: "rtl" }}>

          <div className="">
            <h6>اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله</h6>
            <textarea value={noteValue} onChange={(e) => setNoteValue(e.target.value)} style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id=""></textarea>

          </div>
          <div className='my-3'>
            <p>اضافة مرفقات</p>
            <label className="cursor w-100" htmlFor="upload-file">
              <div style={{ border: "2px dashed #C6C6C6" }} className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center"

              >
                {imagePreview ?
                  <img
                    src={imagePreview}
                    alt="preview"
                    style={{ width: "100%", height: 150, objectFit: "cover", borderRadius: 10 }}
                  /> : <div className='text-center'>
                    <DriveFolderUpload sx={{ fontSize: "50px", color: "#535353" }} />

                    <p style={{ color: "#535353", margin: 0 }}>اضف ملف </p>
                  </div>}
                <input type="file" onChange={FileChange} className="d-none" id="upload-file" />



              </div>
            </label>
          </div>
          <div className="d-flex justify-content-center align-items-center my-5 gap-4">

            <button onClick={() => saveNote(noteValue)} className="btn btn-dark px-4">حفظ الفحص</button>

          </div>
        </Modal.Body>

      </Modal>
    <div className="m-4" dir="rtl">
      {loading || !order &&
   <div className="text-center my-5">Loading...</div>
}
       <div className="border rounded-4 min-vh-100">
         <div className="border rounded-4 p-4">
            <p className="m-0 fw-semibold">{`خدمات الطلب  # Order-${order?.id}`}</p>
        </div>
          <div className="p-4">
                      <div className="d-flex gap-3  m-3">
                        <span className="small fw-bold text-muted">تم</span>
                        <span className="small fw-bold text-muted">لم يتم</span>
                      </div>

            {
  order?.categories?.map(category =>
    category.subcategories?.map(sub =>{
      const isOtherItem = category.slug === "cover" 
      return(
      <div key={sub.id}>
        <div className="d-flex gap-2 align-items-center pt-3">
          <img
            className="services-images-url"
            src={
              category.icon_url
                ? category.slug === "cover"
                  ? category.icon_url
                  : `${newImageUrl}${category.icon_url}`
                : defaultImage
            }
            alt=""
          />

          <h6 className="m-0 main-text-color">
            {sub.name}
          </h6>
        </div>

        {!isOtherItem && sub.items
          ?.filter(
            item =>
              item.item_type !==
              "other_request_service"
          )
          .map(service =>
            renderServiceRow(service)
          )}
      </div>
    )}
  
  )
  )
}{
  otherItems?.map(request =>
    request.services?.map(service =>
      service.status === "accepted_by_user"
        ? renderServiceRow(service)
        : null
    )
  )
}
            </div>
        
       </div>
           <div className="d-flex justify-content-center mt-3 fixed-footer w-100">
{allowedStatuses.includes(order?.status) && (
  <button
  className='btn btn-dark px-5 w-75'
  disabled={order.status === "in_progress" && !isAllItemsChecked}
  onClick={handleAction}
>
  {order.status === "arrived_at_location" && "صور قبل التنفيذ"}

{order.status === "in_progress" && !isInspectionSaved && "صور بعد التنفيذ"}

{order.status === "in_progress" && isInspectionSaved && !isAfterImagesUploaded && "صور بعد التنفيذ"}

{order.status === "in_progress" && isInspectionSaved && isAfterImagesUploaded && "انهاء تنفيذ الطلب"}

{order.status === "awaiting_payment" && "تأكيد تنفيذ الطلب"}
</button>

)}
 
        </div>
    </div>
    
    </>
  )
}

export default CheckOrderItems